module.exports = __webpack_public_path__ + "img/add-mwindow.788e7c55.svg";